import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const FrameDepth = ({ value, onChange, label = 'Frame Depth', screen = null, disabled = false }) => {
    const [selectedFrameDepth, setSelectedFrameDepth] = useState(value || '3"');
    const [visibleOptions, setVisibleOptions] = useState(['3"', "4 1/2\" w/Frame Extension for Retractable Screen"]);
    

    const handleFrameDepthChange = (e) => {
        const newValue = e.target.value;
        setSelectedFrameDepth(newValue);
        onChange(newValue);
    };

    useEffect(() => {
        if (screen === "Yes") {
            setVisibleOptions(["4 1/2\" w/Frame Extension for Retractable Screen"]);
            if (selectedFrameDepth === '3"') {
                setSelectedFrameDepth("4 1/2\" w/Frame Extension for Retractable Screen");
                onChange("4 1/2\" w/Frame Extension for Retractable Screen");
            }
        } else if (screen === "No") {
            setVisibleOptions(['3"']);
            if (selectedFrameDepth === "4 1/2\" w/Frame Extension for Retractable Screen") {
                setSelectedFrameDepth('3"');
                onChange('3"');
            }
        } else {
            //setVisibleOptions(['3"', "4 1/2\" w/Frame Extension for Retractable Screen"]);
            setVisibleOptions(['3"']);
            if (selectedFrameDepth === "4 1/2\" w/Frame Extension for Retractable Screen") {
                setSelectedFrameDepth('3"');
                onChange('3"');
            }
        }
    }, [screen]);

    const labelMap = {
        '3"': '3"',
        "4 1/2\" w/Frame Extension for Retractable Screen": "4 1/2\" w/Frame Extension for Retractable Screen"
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="FrameDepth">{label}</label>
            <select
                disabled={disabled}
                id="FrameDepth"
                value={selectedFrameDepth}
                onChange={handleFrameDepthChange}
            >
                {visibleOptions.map((opt) => (
                    <option key={opt} value={opt}>
                        {selectedFrameDepth === opt ? `${labelMap[opt]} ✔` : labelMap[opt]}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default FrameDepth;
